import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateWindow } from '../../../actions/interactableActions'
import { closeModal } from 'actions/modalActions'
import { useContext } from '../../../hooks/useURL'

const ArrangeWindowTile = (props) => {


    const { name, windowConfig } = props
    const container = useSelector(state => state.interactableState.container) || {}
    const [selectedTile, setSelectedTile] = useState()
    const dispatch = useDispatch()
    const { x, y, width, height, ...rest } = windowConfig

    const {
        width: unadjustedContainerWidth,
        height: unadjustedContainerHeight,
        verticalOffset = 0,
        horizontalOffset = 0
      } = container
    
      // the container on the patient display has a vertical offset to account for the height of the patient header which can be
      // different for each selected header type. When not on patient display vertical offset will be 0. Below we calculate the
      // containterHeight (actual) but subtracing the vertical offset value from the full/unadjusted contaienr height (which dosent
      // account for the header)
      // additionally we need to add the vertical offset to the Y position of all windows. As an easy general purpose way to do this,
      // I created an offsetAndUpdateWindow wrapper for the offsetAndUpdateWindow action that applies this offset
      //
      // although not yet used, we do have support for horizontal offset so that is handled in the same way here
      const containerHeight = unadjustedContainerHeight - verticalOffset
      const containerWidth = unadjustedContainerWidth - horizontalOffset
      const offsetAndUpdateWindow = useCallback(windowConfig => {
        windowConfig.y += verticalOffset
        windowConfig.x += horizontalOffset
        return updateWindow(windowConfig)
      }, [])



    const handleTileClick = useCallback((e) => {
        const padding = 10;

        setSelectedTile(e.target.className)

        if (e.target.className === 'window tile') {
            dispatch(offsetAndUpdateWindow({
                width: containerWidth,
                height: containerHeight - padding,
                x: 0,
                y: 0,
                ...rest
            }))
        } else if (e.target.className === 'window tile-2-top') {
            dispatch(offsetAndUpdateWindow({
                width: containerWidth,
                height: (containerHeight / 2) - padding,
                x: 0,
                y: 0,
                ...rest
            }))
        } else if (e.target.className === 'window tile-2-bottom') {
            dispatch(offsetAndUpdateWindow({
                width: containerWidth,
                height: (containerHeight / 2) - padding,
                x: 0,
                y: containerHeight / 2,
                ...rest
            }))
        } else if (e.target.className === 'window tile-3-left') {
            dispatch(offsetAndUpdateWindow({
                width: (containerWidth / 3) - padding,
                height: containerHeight,
                x: 0,
                y: 0,
                ...rest
            }))
        }
        else if (e.target.className === 'window tile-3-right') {
            dispatch(offsetAndUpdateWindow({
                width: ((2 * containerWidth) / 3) - padding,
                height: containerHeight,
                x: (containerWidth) / 3,
                y: 0,
                ...rest
            }))
        } else if (e.target.className === 'window tile-4-top') {
            dispatch(offsetAndUpdateWindow({
                width: containerWidth,
                height: ((2 * containerHeight) / 3) - padding,
                x: 0,
                y: 0,
                ...rest
            }))
        } else if (e.target.className === 'window tile-4-bottom') {
            dispatch(offsetAndUpdateWindow({
                width: containerWidth,
                height: (containerHeight / 3) - padding,
                x: 0,
                y: (2 * containerHeight) / 3,
                ...rest
            }))
        } else if (e.target.className === 'window tile-5-top-left') {
            dispatch(offsetAndUpdateWindow({
                width: ((2 * containerWidth) / 3) - padding,
                height: (containerHeight / 2) - padding,
                x: 0,
                y: 0,
                ...rest
            }))
        } else if (e.target.className === 'window tile-5-bottom-left') {
            dispatch(offsetAndUpdateWindow({
                width: ((2 * containerWidth) / 3) - padding,
                height: (containerHeight / 2) - padding,
                x: 0,
                y: containerHeight / 2,
                ...rest
            }))
        } else if (e.target.className === 'window tile-5-top-right') {
            dispatch(offsetAndUpdateWindow({
                width: ((containerWidth) / 3) - padding,
                height: (containerHeight / 2) - padding,
                x: (2 * containerWidth) / 3,
                y: 0,
                ...rest
            }))
        } else if (e.target.className === 'window tile-5-bottom-right') {
            dispatch(offsetAndUpdateWindow({
                width: ((containerWidth) / 3) - padding,
                height: (containerHeight / 2) - padding,
                x: (2 * containerWidth) / 3,
                y: containerHeight / 2,
                ...rest
            }))
        } else if (e.target.className === 'window tile-6-top-left') {
            dispatch(offsetAndUpdateWindow({
                width: (containerWidth / 2) - padding,
                height: ((2 * containerHeight) / 3) - padding,
                x: 0,
                y: 0,
                ...rest
            }))
        } else if (e.target.className === 'window tile-6-bottom-left') {
            dispatch(offsetAndUpdateWindow({
                width: (containerWidth / 2) - padding,
                height: (containerHeight / 3) - padding,
                x: 0,
                y: (2 * containerHeight) / 3,
                ...rest
            }))
        } else if (e.target.className === 'window tile-6-top-right') {
            dispatch(offsetAndUpdateWindow({
                width: (containerWidth / 2) - padding,
                height: ((2 * containerHeight) / 3) - padding,
                x: containerWidth / 2,
                y: 0,
                ...rest
            }))
        } else if (e.target.className === 'window tile-6-bottom-right') {
            dispatch(offsetAndUpdateWindow({
                width: (containerWidth / 2) - padding,
                height: (containerHeight / 3) - padding,
                x: containerWidth / 2,
                y: (2 * containerHeight) / 3,
                ...rest
            }))
        } else if (e.target.className === 'window tile-7-top-left') {
            dispatch(offsetAndUpdateWindow({
                width: (containerWidth / 2) - padding,
                height: (containerHeight / 2) - padding,
                x: 0,
                y: 0,
                ...rest
            }))
        } else if (e.target.className === 'window tile-7-bottom-left') {
            dispatch(offsetAndUpdateWindow({
                width: (containerWidth / 2) - padding,
                height: (containerHeight / 2) - padding,
                x: 0,
                y: containerHeight / 2,
                ...rest
            }))
        } else if (e.target.className === 'window tile-7-top-right') {
            dispatch(offsetAndUpdateWindow({
                width: (containerWidth / 2) - padding,
                height: (containerHeight / 2) - padding,
                x: containerWidth / 2,
                y: 0,
                ...rest
            }))
        } else if (e.target.className === 'window tile-7-bottom-right') {
            dispatch(offsetAndUpdateWindow({
                width: (containerWidth / 2) - padding,
                height: (containerHeight / 2) - padding,
                x: containerWidth / 2,
                y: containerHeight / 2,
                ...rest
            }))
        } else if (e.target.className === 'window tile-8-left') {
            dispatch(offsetAndUpdateWindow({
                width: (containerWidth / 2) - padding,
                height: containerHeight,
                x: 0,
                y: 0,
                ...rest
            }))
        } else if (e.target.className === 'window tile-8-right') {
            dispatch(offsetAndUpdateWindow({
                width: (containerWidth / 2) - padding,
                height: containerHeight,
                x: containerWidth / 2,
                y: 0,
                ...rest
            }))
        } else if (e.target.className === 'window tile-9-left') {
            dispatch(offsetAndUpdateWindow({
                width: ((2 * containerWidth) / 3) - padding,
                height: containerHeight,
                x: 0,
                y: 0,
                ...rest
            }))
        } else if (e.target.className === 'window tile-9-right') {
            dispatch(offsetAndUpdateWindow({
                width: (containerWidth / 3) - padding,
                height: containerHeight,
                x: (2 * containerWidth) / 3,
                y: 0,
                ...rest
            }))
        } else if (e.target.className === 'window tile-10-top') {
            dispatch(offsetAndUpdateWindow({
                width: containerWidth,
                height: (containerHeight / 3) - padding,
                x: 0,
                y: 0,
                ...rest
            }))
        } else if (e.target.className === 'window tile-10-bottom') {
            dispatch(offsetAndUpdateWindow({
                width: containerWidth,
                height: ((2 * containerHeight) / 3) - padding,
                x: 0,
                y: containerHeight / 3,
                ...rest
            }))
        } else if (e.target.className === 'window tile-11-top-left') {
            dispatch(offsetAndUpdateWindow({
                width: (containerWidth / 3) - padding,
                height: (containerHeight / 2) - padding,
                x: 0,
                y: 0,
                ...rest
            }))
        }
        else if (e.target.className === 'window tile-11-bottom-left') {
            dispatch(offsetAndUpdateWindow({
                width: (containerWidth / 3) - padding,
                height: (containerHeight / 2) - padding,
                x: 0,
                y: containerHeight / 2,
                ...rest
            }))
        } else if (e.target.className === 'window tile-11-top-right') {
            dispatch(offsetAndUpdateWindow({
                width: ((2 * containerWidth) / 3) - padding,
                height: (containerHeight / 2) - padding,
                x: (containerWidth) / 3,
                y: 0,
                ...rest
            }))
        } else if (e.target.className === 'window tile-11-bottom-right') {
            dispatch(offsetAndUpdateWindow({
                width: ((2 * containerWidth) / 3) - padding,
                height: (containerHeight / 2) - padding,
                x: (containerWidth) / 3,
                y: containerHeight / 2,
                ...rest
            }))
        } else if (e.target.className === 'window tile-12-top-left') {
            dispatch(offsetAndUpdateWindow({
                width: (containerWidth / 2) - padding,
                height: (containerHeight / 3) - padding,
                x: 0,
                y: 0,
                ...rest
            }))
        } else if (e.target.className === 'window tile-12-bottom-left') {
            dispatch(offsetAndUpdateWindow({
                width: (containerWidth / 2) - padding,
                height: ((2 * containerHeight) / 3) - padding,
                x: 0,
                y: containerHeight / 3,
                ...rest
            }))
        } else if (e.target.className === 'window tile-12-top-right') {
            dispatch(offsetAndUpdateWindow({
                width: (containerWidth / 2) - padding,
                height: (containerHeight / 3) - padding,
                x: containerWidth / 2,
                y: 0,
                ...rest
            }))
        } else if (e.target.className === 'window tile-12-bottom-right') {
            dispatch(offsetAndUpdateWindow({
                width: (containerWidth / 2) - padding,
                height: ((2 * containerHeight) / 3) - padding,
                x: containerWidth / 2,
                y: containerHeight / 3,
                ...rest
            }))
        }
        dispatch(closeModal("arrange_window_tile_modal"))
    }, [containerWidth, containerHeight])


    return (
        <div className='tiling-modal'>
            <div className="tiling-area">
                <div className="window-tile-1"
                    style={{ width: '100px', height: '100px' }}
                >
                    <div className={`window tile ${selectedTile == 'tile' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}
                    ></div>
                </div>
                <div className="window-tile-2"
                    style={{
                        width: '100px',
                        height: '100px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between'
                    }}>
                    <div className={`window tile-2-top ${selectedTile === 'window tile-2-top' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}
                    >
                    </div>
                    <div className={`window tile-2-bottom ${selectedTile === 'window tile-2-bottom' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}
                    ></div>
                </div>
                <div className="window-tile-3"
                    style={{
                        width: '100px',
                        height: '100px',
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}
                >
                    <div className={`window tile-3-left ${selectedTile === 'window tile-3-left' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}
                    ></div>
                    <div className={`window tile-3-right ${selectedTile === 'window tile-3-right' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}>
                    </div>
                </div>
                <div className="window-tile-4"
                    style={{
                        width: '100px',
                        height: '100px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between'
                    }}
                >
                    <div className={`window tile-4-top ${selectedTile === 'window tile-4-top' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}
                    ></div>
                    <div className={`window tile-4-bottom ${selectedTile === 'window tile-4-bottom' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}
                    ></div>
                </div>
                <div className="window-tile-5"
                    style={{
                        width: '100px',
                        height: '100px',
                        display: 'grid',
                        gridTemplateColumns: 'auto auto auto',
                        gridGap: '2px'
                    }}
                >
                    <div className={`window tile-5-top-left ${selectedTile === 'window tile-5-top-left' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                    <div className={`window tile-5-top-right ${selectedTile === 'window tile-5-top-right' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                    <div className={`window tile-5-bottom-left ${selectedTile === 'window tile-5-bottom-left' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                    <div className={`window tile-5-bottom-right ${selectedTile === 'window tile-5-bottom-right' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                </div>
                <div className="window-tile-6"
                    style={{
                        width: '100px',
                        height: '100px',
                        display: 'grid',
                        gridTemplateRows: 'auto auto auto',
                        gridGap: '2px'
                    }}
                >
                    <div className={`window tile-6-top-left ${selectedTile === 'window tile-6-top-left' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                    <div className={`window tile-6-bottom-left ${selectedTile === 'window tile-6-bottom-left' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                    <div className={`window tile-6-top-right ${selectedTile === 'window tile-6-top-right' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                    <div className={`window tile-6-bottom-right ${selectedTile === 'window tile-6-bottom-right' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                </div>
                <div className="window-tile-7"
                    style={{
                        width: '100px',
                        height: '100px',
                        display: 'grid',
                        gridTemplateColumns: 'auto auto',
                        gridGap: '2px'
                    }}
                >
                    <div className={`window tile-7-top-left ${selectedTile === 'window tile-7-top-left' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                    <div className={`window tile-7-top-right ${selectedTile === 'window tile-7-top-right' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                    <div className={`window tile-7-bottom-left ${selectedTile === 'window tile-7-bottom-left' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                    <div className={`window tile-7-bottom-right ${selectedTile === 'window tile-7-bottom-right' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                </div>
                <div className="window-tile-8"
                    style={{
                        width: '100px',
                        height: '100px',
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}
                >
                    <div className={`window tile-8-left ${selectedTile === 'window tile-8-left' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                    <div className={`window tile-8-right ${selectedTile === 'window tile-8-right' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                </div>
                <div className="window-tile-9"
                    style={{
                        width: '100px',
                        height: '100px',
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}
                >
                    <div className={`window tile-9-left ${selectedTile === 'window tile-9-left' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                    <div className={`window tile-9-right ${selectedTile === 'window tile-9-right' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                </div>
                <div className="window-tile-10"
                    style={{
                        width: '100px',
                        height: '100px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between'
                    }}
                >
                    <div className={`window tile-10-top ${selectedTile === 'window tile-10-top' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                    <div className={`window tile-10-bottom ${selectedTile === 'window tile-10-bottom' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                </div>
                <div className="window-tile-11"
                    style={{
                        width: '100px',
                        height: '100px',
                        display: 'grid',
                        gridTemplateColumns: 'auto auto auto',
                        gridGap: '2px'
                    }}
                >
                    <div className={`window tile-11-top-left ${selectedTile === 'window tile-11-top-left' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                    <div className={`window tile-11-top-right ${selectedTile === 'window tile-11-top-right' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                    <div className={`window tile-11-bottom-left ${selectedTile === 'window tile-11-bottom-left' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                    <div className={`window tile-11-bottom-right ${selectedTile === 'window tile-11-bottom-right' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                </div>
                <div className="window-tile-12"
                    style={{
                        width: '100px',
                        height: '100px',
                        display: 'grid',
                        gridTemplateRows: 'auto auto auto',
                        gridGap: '2px'
                    }}
                >
                    <div className={`window tile-12-top-left ${selectedTile === 'window tile-12-top-left' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                    <div className={`window tile-12-bottom-left ${selectedTile === 'window tile-12-bottom-left' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                    <div className={`window tile-12-top-right ${selectedTile === 'window tile-12-top-right' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                    <div className={`window tile-12-bottom-right ${selectedTile === 'window tile-12-bottom-right' ? 'selected' : ''}`.trim()}
                        onClick={(e) => handleTileClick(e)}></div>
                </div>
            </div>
            <div className='tiling-footer' style={{ marginTop: '25px', display: 'flex', justifyContent: 'flex-end' }}>
                <button className="btn btn-danger" onClick={() => dispatch(closeModal("arrange_window_tile_modal"))}>
                    Cancel
                </button>
            </div>
        </div>
    )
}

export default ArrangeWindowTile